import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useProductPricesOptions } from "~/modules/Products/hooks/useProductPricesOptions";
import { useProductTaskAutomation } from "~/modules/Products/hooks/useProductTaskAutomation";
import { encodeAccessSource } from "./accessSource";

/**
 * Grouped options for the "Źródło dostępu" select: the other products of the
 * owner (an access that follows theirs), this product's prices, and a bare date.
 */
export const useAccessSourceOptions = (productId: string) => {
  const { t } = useTranslation("products");
  const priceOptions = useProductPricesOptions();
  const { productWithPrices } = useProductTaskAutomation(productId);

  return useMemo(
    () => [
      {
        label: t("import.accessSource.groupLinked"),
        options: productWithPrices.map((product) => ({
          label: product.name,
          value: encodeAccessSource({ kind: "linked", sourceProductId: product.id }),
        })),
      },
      {
        label: t("import.accessSource.groupPrice"),
        options: priceOptions.map((option) => ({
          label: option.label,
          value: encodeAccessSource({ kind: "price", priceId: option.value }),
        })),
      },
      {
        label: t("import.accessSource.groupOther"),
        options: [{ label: t("import.accessSource.manual"), value: encodeAccessSource({ kind: "manual" }) }],
      },
    ],
    [priceOptions, productWithPrices, t],
  );
};
